<template>
  <custom-scroll :is-scroll-y-available="true" :id="customScrollId">
    <v-layout
      align-top
      :class="[['creative-container'],{'align-start': alignStart}]"
    >
      <!-- Facebook Ad Preview -->
      <v-flex
        shrink
        v-if="showFacebookPreview"
      >
        <v-container
          fluid
          pa-1
          ma-0
          class="creative"
        >
          <v-layout
            wrap
            ma-0
            pa-0
            class="elevation-2 overflow-hidden"
          >
            <v-flex
              xs12
              grow
              ma-0
              pa-0
              class="creative-header"
            >
              <v-card
                flat
                class="creative-header-card d-flex"
                height="45"
              >
                <v-list-tile class="creative-header-card-tile" avatar>
                  <v-list-tile-avatar class="logo">
                    <v-img
                      contain
                      my-5
                      :src="facebookLogo"
                      :lazy-src="facebookLogo"
                      alt="logo"
                    />
                  </v-list-tile-avatar>

                  <v-list-tile-content class="page-info ml-2 mt-1">
                    <v-list-tile-title
                      class="font-weight-bold name"
                    >
                      {{ textTruncate(facebookAdDetails.pageName, 20, "...") }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="sponsered-text grey--text">
                      <small>{{ `Sponsored \u00b7 ` }}</small>
                      <v-icon small class="sponsered-icon">
                        public
                      </v-icon>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action class="settings">
                    <v-btn
                      icon
                      :ripple="false"
                      class="ma-0 mb-1 pa-0"
                    >
                      <v-icon small color="grey">
                        more_horiz
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              grow
              ma-0
              pa-0
              class="creative-content-text"
            >
              <v-card
                flat
                tile
                class="creative-content-text-card"
              >
                <v-container ma-0 pa-0>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      md12
                      sm12
                      lg12
                      class="post-text"
                      mb-1
                      mt-0
                      mx-1
                    >
                      {{ toCustomTitleCase(facebookAdDetails.postText) }}
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              grow
              ma-0
              pa-0
              class="creative-content-wrapper"
            >
              <!-- <v-img
                v-if="!(template && template.logo)"
                :src="previewUnavailableImage"
              /> -->
              <!-- To enable previewunavailble - add v-else below and uncomment above code -->
              <creative
                :template="template"
                :passed-extracted-creative-details="extractedCreativeDetails"
                :is-elevation-and-border-visible="false"
                :enable-on-update-loader="enableShimmerLoader"
              />
            </v-flex>
            <v-flex
              xs12
              grow
              ma-0
              pa-0
              class="creative-footer grey lighten-3"
            >
              <v-card
                flat
                class="d-flex creative-footer-wrapper"
                color="grey lighten-3"
                height="50"
              >
                <v-list-tile avatar>
                  <v-list-tile-content class="text">
                    <v-list-tile-title
                      class="font-weight-bold headline-text"
                    >
                      {{ toCustomTitleCase(facebookAdDetails.headline) }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      class="description-text"
                    >
                      {{ toCustomTitleCase(facebookAdDetails.description) }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action class="call-to-action">
                    <v-btn
                      :ripple="false"
                      outline
                      size="small"
                    >
                      {{ callToActionText }}
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <!-- Instagram Ad Preview -->
      <v-flex
        shrink
        :class="{'ml-4': $vuetify.breakpoint.smAndDown, 'ml-3': $vuetify.breakpoint.mdAndUp}"
        v-if="showInstagramPreview"
      >
        <v-container
          fluid
          pa-1
          ma-0
          class="creative"
        >
          <v-layout
            wrap
            ma-0
            pa-0
            class="elevation-2 overflow-hidden"
          >
            <v-flex
              xs12
              ma-0
              pa-0
              class="creative-header"
            >
              <v-card
                flat
                class="creative-header-card d-flex"
                height="45"
              >
                <v-list-tile class="creative-header-card-tile" avatar>
                  <v-list-tile-avatar class="logo">
                    <v-img
                      contain
                      :src="instagramLogo"
                      :lazy-src="instagramLogo"
                      alt="logo"
                    />
                  </v-list-tile-avatar>

                  <v-list-tile-content class="page-info ml-2 mt-1">
                    <v-list-tile-title
                      class="font-weight-bold name"
                    >
                      {{ textTruncate(facebookAdDetails.pageName, 20, "...") }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="sponsered-text grey--text">
                      <small>{{ `Sponsored` }}</small>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action class="settings">
                    <v-btn
                      icon
                      :ripple="false"
                      class="ma-0 mb-1 pa-0"
                    >
                      <v-icon small color="grey">
                        more_vert
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              grow
              ma-0
              pa-0
              class="creative-content-wrapper"
            >
              <!-- <v-img
                v-if="!(template && template.logo)"
                :src="previewUnavailableImage"
              /> -->
              <!-- To enable previewunavailble - add v-else below and uncomment above code -->
              <creative
                :template="template"
                :passed-extracted-creative-details="extractedCreativeDetails"
                :is-elevation-and-border-visible="false"
                :enable-on-update-loader="enableShimmerLoader"
              />
            </v-flex>

            <v-flex xs12 mx-2 my-1>
              <v-layout align-center>
                <v-flex shrink>
                  <span style="font-weight:bold; font-size:small;">{{ callToActionText }}</span>
                </v-flex>
                <v-spacer />
                <v-flex shrink>
                  <v-icon>chevron_right</v-icon>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 ml-2 mr-3>
              <hr style="margin: 0 !important; border-top: 1px solid #f1f1f1">
            </v-flex>

            <v-flex xs12 mx-2 mt-2>
              <v-layout>
                <v-flex shrink mr-2>
                  <v-img
                    :src="likeImage"
                    :lazy-src="likeImage"
                    :min-width="20"
                    alt="like"
                  />
                </v-flex>
                <v-flex shrink mr-2>
                  <v-img
                    :src="commentImage"
                    :lazy-src="commentImage"
                    :min-width="20"
                    alt="comment"
                  />
                </v-flex>
                <v-flex shrink mr-2>
                  <v-img
                    :src="shareImage"
                    :lazy-src="shareImage"
                    :min-width="20"
                    alt="send"
                  />
                </v-flex>
                <v-spacer />
                <v-flex shrink align-self-end mr-1>
                  <v-img
                    :src="bookmarkImage"
                    :lazy-src="bookmarkImage"
                    :min-width="20"
                    alt="bookmark"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 mx-2 mt-1>
              <v-layout>
                <span style="font-weight:bold; font-size:small;">{{ "91 likes" }}</span>
                <v-spacer />
              </v-layout>
            </v-flex>

            <v-flex xs12 mx-2 mb-1>
              <v-layout>
                <div class="caption">
                  <span style="font-weight:bold;">{{ facebookAdDetails.pageName }}: </span>{{ toCustomTitleCase(facebookAdDetails.postText) }}
                </div>
                <v-spacer />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </custom-scroll>
</template>
<script>
import {
  VContainer,
  VLayout,
  VFlex,
  VSpacer,
  VBtn,
  VCard,
  VListTile,
  VListTileAvatar,
  VListTileContent,
  VListTileAction,
  VListTileTitle,
  VListTileSubTitle,
  VIcon,
  VImg
} from 'vuetify/lib';
import CustomScroll from '../../../../../components/CustomScroll/CustomScroll.vue';
import {  mapActions, mapGetters } from 'vuex';
import { textTruncate } from 'Helpers/helpers';
import { callToActions, objectiveType, offerType, bizgainOnboardingImage } from '../../../constants';
import Creative from '../../imageCreatives/components/Creative.vue';
import { toCustomTitleCase } from 'Features/bizgainOnboarding/helpers/textCaseConvertHelper';

export default {
  data(){
    return{
      textTruncate,
      headline: null,
      description: null,
      postText: null,
      logo: null,
      pageName: null,
      likeImage: bizgainOnboardingImage.like,
      commentImage: bizgainOnboardingImage.comment,
      shareImage: bizgainOnboardingImage.share,
      bookmarkImage: bizgainOnboardingImage.bookmark,
      facebookLogo: bizgainOnboardingImage.facebookLogo,
      instagramLogo: bizgainOnboardingImage.instagramLogo,
      previewUnavailableImage: bizgainOnboardingImage.previewUnavailable
    }
  },
  props: {
    customScrollId: {
      type: String,
      default: 'id'
    },
    template: {
      type: Object,
      default: null
    },
    facebookAdDetails: {
      type: Object,
      default: null
    },
    extractedCreativeDetails: {
      type: Object,
      default: null
    },
    showFacebookPreview: {
      type: Boolean,
      default: false
    },
    showInstagramPreview: {
      type: Boolean,
      default: false
    },
    alignStart: {
      type: Boolean,
      default: false
    },
    enableShimmerLoader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'creativeImages', 'objective', 'offerDetail']),
    callToActionText(){
      let CTAText;
      switch(this.objective){
        case objectiveType.calls.id: CTAText = callToActions.CALL_NOW.label; break;
        case objectiveType.leadGeneration.id:
        case objectiveType.websiteVisits.id:
        case objectiveType.instantMessages.id:
          CTAText = Object.values(callToActions).find(callToAction=>callToAction.value == this.facebookAdDetails.callToAction).label;
          break;
        default:
          if(this.offerDetail.type == offerType.skip){
            CTAText = callToActions.LEARN_MORE.label
          }else{
            CTAText = callToActions.GET_OFFER.label
          }
          break;
      }
      return CTAText;
    }
  },
  methods: {
    ...mapActions(['updateCreativeLoader', 'setCreativeImages']),
    toCustomTitleCase
  },

  components: {
    VContainer,
    VLayout,
    VFlex,
    VSpacer,
    VBtn,
    VCard,
    VListTile,
    VListTileAvatar,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VIcon,
    VImg,
    VListTileAction,
    Creative,
    CustomScroll
  }
};
</script>
<style lang="scss" scoped>
/*
  Setting height same as that of v-tab
*/
.creative-container {
  min-height: inherit;
  justify-content: start;
}

::v-deep .creative {
      width:218px !important;
      min-width:218px;
  .creative-header {
    min-height:50px;
    .v-list__tile {
      padding-top: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
      padding-left: 6px;
    }
    .logo .v-avatar {
      height: 35px;
      width: 35px;
    }
    .v-list__tile__avatar {
      min-width: 26px;
    }
    .name {
      height: 20px;
      font-size: 12px;
      line-height: 2.1;
    }
    .sponsered-text {
      height: 20px;
      font-size: 10px;
      line-height: 1.4;
    }
    .sponsered-icon {
      font-size: 9px !important;
      line-height: 1.6;
    }
    .settings{
      min-width: unset !important;
    }
  }

  .creative-content-text {
    .creative-content-text-card{
      height: fit-content !important;
      .post-text {
          font-size: 10.5px;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: start;
          word-break: break-word;
        }
    }
  }

  .caption{
    font-size: 10.5px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
      word-break: break-word;
  }

  .creative-content-wrapper{
    min-height: 210px;
  }

  .creative-footer {
    .headline-text {
      height: 20px;
      font-size: 11px;
      line-height: 2.2;
      max-width: 135px;
    }

    .description-text {
      height: 20px;
      font-size: 11px;
      line-height: 1.4;
      max-width: 135px;
      color: var(--v-gray-base);
    }

    .v-list__tile {
      padding-top: 0px;
      padding-right: 6px;
      padding-bottom: 0px;
      padding-left: 6px;
    }
    .call-to-action {
      height: unset;
      width: unset;
      .v-btn {
        min-width: 60px;
        padding-left: 2px;
        padding-right: 2px;
        height: 20px;
        font-size: 9px ;
        border-radius: 3px;
        border-color: var(--v-gray-base);
        pointer-events: none;
      }
    }
  }
}
</style>
<style scoped>
@media screen and (min-width:1504px){

    ::v-deep .creative-header-card-tile{
      margin-top: 4px !important;
    }

    ::v-deep .v-avatar {
      height: 50px !important;
      width: 50px !important;
    }

    ::v-deep .name {
      font-size: 16px !important;
      line-height: 1.3 !important;
    }

    ::v-deep .sponsered-text {
      font-size: 16px !important;
    }

    ::v-deep .sponsered-icon {
      line-height: 2.2 !important;
    }

    ::v-deep .creative {
      height: fit-content !important;
      width: 20vw !important;
      min-width:218px;
    }

    ::v-deep .creative-header {
      min-height: fit-content!important;
    }

    ::v-deep .post-text{
      font-size: 14px !important;
    }

    ::v-deep .caption{
      font-size: 14px !important
    }

    ::v-deep .creative-header-card{
      height: fit-content !important;
    }

    ::v-deep .creative-content-text {
      max-height: fit-content!important;
    }

    ::v-deep .creative-content-wrapper{
      min-height: 32vh !important;
    }

    ::v-deep .headline-text {
      font-size: 16px !important;
      line-height: unset !important;
      height: 3.5vh !important;
      max-width: 10vw !important;
    }

    ::v-deep .creative-footer {
      min-height: 6vh !important;
    }

    ::v-deep .creative-footer-wrapper{
       height: inherit !important;
       align-self:center;
    }

    ::v-deep .description-text {
      font-size: 14px !important;
      height: 3vh !important;
      max-width: 10vw !important;
    }

    ::v-deep .v-btn{
      min-width: 4vw !important;
      height: 3vh!important;
      font-size: 16px !important;
      padding:10px;
    }
}

@media screen and (min-width:900px){
  ::v-deep .creative-container {
      justify-content: center;
  }
  ::v-deep .align-start {
    justify-content: start !important;
  }
}
</style>